import { api } from './api';

export const fetchLocations = (params, options) => {
  const queryString = Object.keys(params)
    .map((key) => key + '=' + params[key])
    .join('&');
  return api.get(`/location?${queryString}`, undefined, options);
};

export const fetchLocationsById = (id) => {
  return api.get(`/location/${id}`);
};

export const createLocation = (data) => {
  return api.post('/location', data);
};

export const updateLocation = (id, data) => {
  return api.put(`/location/${id}`, data);
};

export const deleteLocation = (id) => {
  return api.delete(`/location/${id}`);
};
